import styled from 'styled-components';

// Styled components
export const Title = styled.h1`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  font-family: Cabin Sketch;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  font-size: 50px;
  letter-spacing: 0.5px;
  text-align: center;
  color: #356193;
  padding: 60px;
`

export const Main = styled.div`
  margin: 50px;
`

export const Loader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 50px;
  flex-wrap: wrap;
`

export const Message = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 20px;
  font-family: Josefin Sans;
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
`

export const Social = styled.p`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 25px;
`
export const Name = styled.p`
  display: flex;
  flex-direction: row;
  font-family: VT323;
  flex-wrap: wrap;
  font-size: 24px;
  justify-content: center;
  padding: 5px;
`

export const Loading = styled.p`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 20px;
`
export const Content = styled.div`
  padding-top: 20px;
  font-family: Cantarell;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const Image = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-basis: 50px;
  flex-wrap: wrap;
`

export const Button = styled.a`
  margin-top: 40px;
  width: 120px;
  height: 40px;
`

export const Click = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`

export const Link = styled.a`
  color: none;
`

export const Display = styled.img`
  padding: 90px;
`



// WEBPACK FOOTER //
// ./src/styled_components.js